import React from "react";

export default function RadioButton({ active, setActive, label }) {
    return (
        <label className='form-radio'>
            <input type='radio' checked={active} onChange={(event) => setActive(event.target.checked)} />
            <i className='form-icon' />
            {label}
        </label>
    )
}
